import React, { useMemo, useState } from "react";

const GIROS = [
  "Restaurante / Cafetería",
  "Abarrotes / Tienda",
  "Ferretería",
  "Carnicería",
  "Farmacia",
  "Gimnasio",
  "Retail / Tienda especializada",
  "Servicios",
  "Otro",
];

const generarLicenciaDemo = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const bloque = () =>
    Array.from({ length: 4 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
  return `EPOS-${bloque()}-${bloque()}-${bloque()}`;
};

const sumarDias = (fecha, dias) => {
  const d = new Date(fecha);
  d.setDate(d.getDate() + dias);
  return d;
};

const fechaMx = (fecha) =>
  new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(fecha);

const DemoEmpaticaPos = () => {
  const [paso, setPaso] = useState("REGISTRO");
  const [copiado, setCopiado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [errores, setErrores] = useState({});
  const [licencia, setLicencia] = useState("");
  const [form, setForm] = useState({
    empresa: "",
    contacto: "",
    celular: "",
    correo: "",
    giro: "",
    observaciones: "",
    privacidad: false,
  });

  const fechaInicio = useMemo(() => new Date(), []);
  const fechaFin = useMemo(() => sumarDias(fechaInicio, 30), [fechaInicio]);

  const setCampo = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
    setErrores((prev) => ({ ...prev, [campo]: undefined }));
  };

  const validar = () => {
    const next = {};
    if (!form.empresa.trim()) next.empresa = "Ingresa el nombre de tu negocio.";
    if (!form.contacto.trim()) next.contacto = "Ingresa tu nombre.";
    if (!form.celular.trim()) next.celular = "Ingresa un celular o WhatsApp.";
    if (!form.correo.trim()) next.correo = "Ingresa tu correo.";
    if (form.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo)) {
      next.correo = "Ingresa un correo válido.";
    }
    if (!form.giro) next.giro = "Selecciona el giro de tu negocio.";
    if (!form.privacidad) next.privacidad = "Debes aceptar el aviso de privacidad.";
    setErrores(next);
    return Object.keys(next).length === 0;
  };

  const registrar = async (e) => {
    e.preventDefault();
    if (!validar()) return;

    setEnviando(true);

    // INTERFAZ DEMO:
    // Aquí se conectará posteriormente el endpoint que crea:
    // 1) la empresa demo
    // 2) una licencia EMPATICAPOS con vigencia de 30 días
    await new Promise((resolve) => setTimeout(resolve, 650));

    setLicencia(generarLicenciaDemo());
    setEnviando(false);
    setPaso("LISTO");
  };

  const copiarLicencia = async () => {
    try {
      await navigator.clipboard.writeText(licencia);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1800);
    } catch {
      window.prompt("Copia tu licencia:", licencia);
    }
  };

  const compartir = async () => {
    const texto = `Mi demo de Empática POS está lista.\nEmpresa: ${form.empresa}\nVigencia: 30 días\nLicencia: ${licencia}`;

    if (navigator.share) {
      try {
        await navigator.share({ title: "Demo Empática POS", text: texto });
        return;
      } catch {
        return;
      }
    }

    const url = `https://wa.me/?text=${encodeURIComponent(texto)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const empezarDeNuevo = () => {
    setPaso("REGISTRO");
    setLicencia("");
    setCopiado(false);
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }
        body { margin: 0; }

        .demo-page {
          min-height: 100vh;
          background:
            radial-gradient(circle at 15% 12%, rgba(37,99,235,.10), transparent 30%),
            linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
          color: #0f172a;
          font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          padding: 28px 18px;
          display: grid;
          place-items: center;
        }

        .demo-shell {
          width: min(1040px, 100%);
          background: #fff;
          border: 1px solid #dfe7f2;
          border-radius: 26px;
          box-shadow: 0 28px 70px rgba(15,23,42,.10);
          overflow: hidden;
          display: grid;
          grid-template-columns: minmax(280px,.75fr) minmax(0,1.25fr);
        }

        .demo-side {
          padding: 38px 34px;
          background: linear-gradient(160deg, #135ebc 0%, #0c4b98 100%);
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 650px;
        }

        .brand-kicker {
          font-size: 13px;
          font-weight: 900;
          letter-spacing: .08em;
          text-transform: uppercase;
          opacity: .85;
        }
        .brand-title { font-size: 34px; line-height: 1.05; margin: 12px 0 14px; font-weight: 950; }
        .brand-copy { color: rgba(255,255,255,.82); line-height: 1.6; font-size: 15px; }

        .benefits { display: grid; gap: 12px; margin-top: 28px; }
        .benefit { display: flex; gap: 10px; align-items: flex-start; font-size: 14px; color: rgba(255,255,255,.92); }
        .benefit-dot {
          width: 24px; height: 24px; border-radius: 999px; flex: 0 0 24px;
          background: rgba(255,255,255,.16); display: grid; place-items: center; font-weight: 900;
        }
        .side-foot { font-size: 12px; color: rgba(255,255,255,.65); line-height: 1.5; }

        .demo-main { padding: 36px 38px 34px; }
        .eyebrow { color: #155eef; font-size: 12px; font-weight: 900; text-transform: uppercase; letter-spacing: .08em; }
        .demo-main h1 { margin: 7px 0 7px; font-size: 28px; line-height: 1.15; }
        .demo-sub { margin: 0 0 24px; color: #64748b; font-size: 14px; line-height: 1.55; }

        .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .field { display: flex; flex-direction: column; gap: 7px; }
        .field.full { grid-column: 1 / -1; }
        .field label { font-size: 13px; font-weight: 850; color: #334155; }
        .req { color: #dc2626; }
        .field input, .field select, .field textarea {
          width: 100%; border: 1px solid #cfd8e6; border-radius: 12px;
          padding: 12px 13px; font: inherit; font-size: 14px; color: #0f172a; background: #fff;
          outline: none; transition: border-color .15s ease, box-shadow .15s ease;
        }
        .field textarea { resize: vertical; min-height: 92px; }
        .field input:focus, .field select:focus, .field textarea:focus {
          border-color: #155eef; box-shadow: 0 0 0 3px rgba(21,94,239,.10);
        }
        .field.error input, .field.error select { border-color: #ef4444; }
        .error-text { color: #b91c1c; font-size: 11px; font-weight: 700; }
        .hint { color: #94a3b8; font-size: 11px; }

        .privacy {
          display: flex; align-items: flex-start; gap: 10px; margin-top: 18px;
          padding: 12px 13px; border-radius: 12px; background: #f8fafc; border: 1px solid #e5e7eb;
        }
        .privacy input { margin-top: 3px; }
        .privacy label { font-size: 12px; color: #475569; line-height: 1.45; }

        .primary-btn {
          width: 100%; margin-top: 18px; border: 0; border-radius: 13px; padding: 14px 16px;
          background: #155eef; color: #fff; font-size: 15px; font-weight: 900; cursor: pointer;
          box-shadow: 0 10px 24px rgba(21,94,239,.20); transition: .18s ease;
        }
        .primary-btn:hover { transform: translateY(-1px); background: #0f52d7; }
        .primary-btn:disabled { opacity: .55; cursor: wait; transform: none; }

        .microcopy { margin: 10px 0 0; text-align: center; color: #94a3b8; font-size: 11px; }

        /* pantalla lista */
        .ready-wrap { max-width: 570px; margin: 0 auto; padding-top: 8px; }
        .success-icon {
          width: 62px; height: 62px; border-radius: 999px; margin-bottom: 17px;
          display: grid; place-items: center; background: #dcfce7; color: #15803d; font-size: 30px; font-weight: 950;
        }
        .ready-wrap h1 { font-size: 30px; margin-bottom: 8px; }
        .ready-summary {
          display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 22px 0 18px;
        }
        .summary-card { background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 13px; padding: 12px; }
        .summary-card span { display: block; color: #64748b; font-size: 11px; font-weight: 800; margin-bottom: 4px; }
        .summary-card strong { display: block; font-size: 14px; }

        .license-card {
          border: 1px solid #b9d3ff; background: #f4f8ff; border-radius: 17px; padding: 16px; margin-bottom: 16px;
        }
        .license-label { color: #475569; font-size: 12px; font-weight: 850; margin-bottom: 7px; }
        .license-row { display: flex; align-items: center; gap: 10px; }
        .license-code {
          flex: 1; min-width: 0; padding: 12px 13px; border-radius: 11px; background: #fff; border: 1px solid #dbe7fb;
          font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 16px; font-weight: 900;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #123b72;
        }
        .copy-btn { border: 0; background: #155eef; color: #fff; border-radius: 11px; padding: 12px 14px; font-weight: 900; cursor: pointer; }
        .license-help { margin-top: 9px; color: #64748b; font-size: 11px; line-height: 1.45; }

        .android-card {
          display: flex; justify-content: space-between; align-items: center; gap: 14px;
          border: 1px solid #e5e7eb; border-radius: 16px; padding: 15px; margin-top: 12px;
        }
        .android-left { display: flex; gap: 12px; align-items: center; min-width: 0; }
        .android-icon { width: 42px; height: 42px; border-radius: 12px; background: #ecfdf5; display: grid; place-items: center; font-size: 22px; }
        .android-title { font-weight: 900; font-size: 14px; }
        .android-sub { color: #64748b; font-size: 11px; margin-top: 2px; }
        .download-btn { border: 0; border-radius: 11px; padding: 10px 12px; background: #0f172a; color: #fff; font-weight: 850; cursor: pointer; white-space: nowrap; }

        .ready-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 16px; }
        .secondary-btn { border: 1px solid #dbe3ee; background: #fff; color: #334155; border-radius: 12px; padding: 12px; font-weight: 850; cursor: pointer; }
        .share-btn { border: 0; background: #16a34a; color: #fff; border-radius: 12px; padding: 12px; font-weight: 900; cursor: pointer; }
        .restart-link { display: block; border: 0; background: transparent; color: #64748b; margin: 16px auto 0; cursor: pointer; font-weight: 800; }

        @media (max-width: 780px) {
          .demo-page { padding: 0; display: block; background: #fff; }
          .demo-shell { display: block; border: 0; border-radius: 0; box-shadow: none; min-height: 100vh; }
          .demo-side { min-height: 0; padding: 24px 20px; }
          .brand-title { font-size: 27px; }
          .brand-copy { font-size: 14px; }
          .benefits { display: none; }
          .side-foot { display: none; }
          .demo-main { padding: 25px 18px 34px; }
          .demo-main h1, .ready-wrap h1 { font-size: 25px; }
          .form-grid { grid-template-columns: 1fr; gap: 13px; }
          .field.full { grid-column: auto; }
          .ready-summary { grid-template-columns: 1fr; }
          .license-row { align-items: stretch; flex-direction: column; }
          .license-code { white-space: normal; overflow-wrap: anywhere; }
          .android-card { align-items: stretch; flex-direction: column; }
          .download-btn { width: 100%; }
          .ready-actions { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="demo-page">
        <div className="demo-shell">
          <aside className="demo-side">
            <div>
              <div className="brand-kicker">Empática POS</div>
              <div className="brand-title">Prueba tu punto de venta por 30 días</div>
              <div className="brand-copy">
                Registra tu negocio, obtén tu licencia demo y prueba Empática POS directamente en un dispositivo Android.
              </div>

              <div className="benefits">
                <div className="benefit"><span className="benefit-dot">✓</span><span>Registro rápido, sin datos fiscales.</span></div>
                <div className="benefit"><span className="benefit-dot">✓</span><span>Licencia demo con vigencia de 30 días.</span></div>
                <div className="benefit"><span className="benefit-dot">✓</span><span>Descarga para Android y acceso inmediato.</span></div>
              </div>
            </div>
            <div className="side-foot">La licencia se utilizará la primera vez que abras Empática POS.</div>
          </aside>

          <main className="demo-main">
            {paso === "REGISTRO" ? (
              <form onSubmit={registrar} noValidate>
                <div className="eyebrow">Demo gratuita</div>
                <h1>Crea tu acceso a Empática POS</h1>
                <p className="demo-sub">Déjanos los datos básicos de tu negocio. Te tomará menos de un minuto.</p>

                <div className="form-grid">
                  <div className={`field ${errores.empresa ? "error" : ""}`}>
                    <label>Empresa / negocio <span className="req">*</span></label>
                    <input value={form.empresa} onChange={(e) => setCampo("empresa", e.target.value)} placeholder="Ej. Cafetería La Estación" autoComplete="organization" />
                    {errores.empresa && <div className="error-text">{errores.empresa}</div>}
                  </div>

                  <div className={`field ${errores.contacto ? "error" : ""}`}>
                    <label>Nombre de contacto <span className="req">*</span></label>
                    <input value={form.contacto} onChange={(e) => setCampo("contacto", e.target.value)} placeholder="Tu nombre" autoComplete="name" />
                    {errores.contacto && <div className="error-text">{errores.contacto}</div>}
                  </div>

                  <div className={`field ${errores.celular ? "error" : ""}`}>
                    <label>Celular / WhatsApp <span className="req">*</span></label>
                    <input value={form.celular} onChange={(e) => setCampo("celular", e.target.value)} placeholder="443 123 4567" inputMode="tel" autoComplete="tel" />
                    {errores.celular && <div className="error-text">{errores.celular}</div>}
                  </div>

                  <div className={`field ${errores.correo ? "error" : ""}`}>
                    <label>Correo electrónico <span className="req">*</span></label>
                    <input type="email" value={form.correo} onChange={(e) => setCampo("correo", e.target.value)} placeholder="correo@empresa.com" autoComplete="email" />
                    {errores.correo && <div className="error-text">{errores.correo}</div>}
                  </div>

                  <div className={`field full ${errores.giro ? "error" : ""}`}>
                    <label>Giro del negocio <span className="req">*</span></label>
                    <select value={form.giro} onChange={(e) => setCampo("giro", e.target.value)}>
                      <option value="">Selecciona una opción</option>
                      {GIROS.map((giro) => <option key={giro} value={giro}>{giro}</option>)}
                    </select>
                    {errores.giro && <div className="error-text">{errores.giro}</div>}
                  </div>

                  <div className="field full">
                    <label>Observaciones <span className="hint">(opcional)</span></label>
                    <textarea value={form.observaciones} onChange={(e) => setCampo("observaciones", e.target.value)} placeholder="Cuéntanos brevemente qué quieres probar o cómo opera tu negocio..." maxLength={500} />
                  </div>
                </div>

                <div className="privacy">
                  <input id="privacidad" type="checkbox" checked={form.privacidad} onChange={(e) => setCampo("privacidad", e.target.checked)} />
                  <label htmlFor="privacidad">Acepto el aviso de privacidad y el uso de mis datos para crear y dar seguimiento a mi demo de Empática POS.</label>
                </div>
                {errores.privacidad && <div className="error-text" style={{ marginTop: 6 }}>{errores.privacidad}</div>}

                <button className="primary-btn" disabled={enviando} type="submit">
                  {enviando ? "Creando tu demo…" : "Crear mi demo gratis"}
                </button>
                <p className="microcopy">Sin tarjeta · Vigencia de 30 días · Disponible para Android</p>
              </form>
            ) : (
              <div className="ready-wrap">
                <div className="success-icon">✓</div>
                <div className="eyebrow">Demo creada</div>
                <h1>¡Tu Empática POS está listo!</h1>
                <p className="demo-sub">Descarga la app para Android e ingresa la siguiente licencia al abrirla por primera vez.</p>

                <div className="ready-summary">
                  <div className="summary-card"><span>Empresa</span><strong>{form.empresa}</strong></div>
                  <div className="summary-card"><span>Vigencia</span><strong>Hasta {fechaMx(fechaFin)}</strong></div>
                </div>

                <div className="license-card">
                  <div className="license-label">Tu licencia de 30 días</div>
                  <div className="license-row">
                    <div className="license-code">{licencia}</div>
                    <button type="button" className="copy-btn" onClick={copiarLicencia}>{copiado ? "Copiada ✓" : "Copiar"}</button>
                  </div>
                  <div className="license-help">Guárdala. La aplicación te la solicitará para activar esta demo.</div>
                </div>

                <div className="android-card">
                  <div className="android-left">
                    <div className="android-icon">🤖</div>
                    <div><div className="android-title">Empática POS para Android</div><div className="android-sub">Instala la app y utiliza tu licencia demo.</div></div>
                  </div>
                  <button type="button" className="download-btn" onClick={() => alert("Aquí se colocará la URL real del APK de Empática POS.")}>Descargar Android</button>
                </div>

                <div className="ready-actions">
                  <button type="button" className="share-btn" onClick={compartir}>Compartir mi acceso</button>
                  <button type="button" className="secondary-btn" onClick={copiarLicencia}>Copiar licencia</button>
                </div>

                <button type="button" className="restart-link" onClick={empezarDeNuevo}>Registrar otra empresa</button>
              </div>
            )}
          </main>
        </div>
      </div>
    </>
  );
};

export default DemoEmpaticaPos;
